export default __webpack_public_path__ + "static/media/7.b0f9c05d.jpg";